export enum ExtendedRouteActions {
  quit = 'quit'
}
